import { render, staticRenderFns } from "./espece.vue?vue&type=template&id=4835c6dc"
import script from "./espece.vue?vue&type=script&lang=js"
export * from "./espece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports